<template>
  <div class="action">
    <button @click="isOpen = !isOpen" class="button is-primary" slot="botton">Update User</button>
    <div :class="['modal', {'is-active': isOpen}]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Update User</p>
          <button @click="cancel" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="field">
              <label class="modal-card-title">Name</label>
              <input
                v-model="form.name"
                @blur="$v.form.name.$touch"
                type="text"
                class="input"
                placeholder="Name"
              />
              <div v-if="$v.form.name.$error" class="form-error">
                <span v-if="!$v.form.name.required" class="help is-danger">Name is Required</span>
              </div>
            </div>
            <!-- <div class="field">
              <label class="modal-card-title">E-mail</label>
              <input
                v-model="form.email"
                @blur="$v.form.email.$touch"
                type="text"
                class="input"
                placeholder="E-mail"
              />
              <div v-if="$v.form.email.$error" class="form-error">
                <span v-if="!$v.form.email.required" class="help is-danger">E-mail is Required</span>
                <span v-if="!$v.form.email.email" class="help is-danger">Email Address is not valid</span>
              </div>
            </div> -->

            <!-- <div class="field">
              <label class="modal-card-title">Password</label>
              <input
                v-model="form.password"
                class="input"
                @blur="$v.form.password.$touch"
                type="password"
              />
              <div v-if="$v.form.password.$error" class="form-error">
                <span v-if="!$v.form.password.required" class="help is-danger">Password is Required</span>
                <span
                  v-if="!$v.form.password.minLength"
                  class="help is-danger"
                >Password Minimum length is 6 characters</span>
              </div>
            </div>
            <div class="field">
              <label class="modal-card-title">Confirm Password</label>
              <input
                v-model="form.passwordConfirm"
                @blur="$v.form.passwordConfirm.$touch"
                type="password"
                class="input"
              />
              <div v-if="$v.form.passwordConfirm.$error" class="form-error">
                <span
                  v-if="!$v.form.passwordConfirm.required"
                  class="help is-danger"
                >Password Confirmation is Required</span>
                <span
                  v-if="!$v.form.passwordConfirm.sameAs"
                  class="help is-danger"
                >Password and Confirm Password are not the same</span>
              </div>
            </div>-->
            <!-- <div class="field">
              <label class="modal-card-title m-b-sm">Please Choose User Role</label>
              <div class="control">
                <div class="select is-primary">
                  <select v-model="form.role">
                    <option>user</option>
                    <option>manager</option>
                    <option>admin</option>
                    <option>question-manager</option>
                  </select>
                </div>
               
              </div>
            </div> -->
             <!-- <div class="field">
              <label class="modal-card-title m-b-sm">Please Verify user</label>
              <div class="control">
                <div class="select is-primary">
                  <select v-model="form.isUserVerified">
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
                <div v-if="form.photoUrl" class="container">
                  <img class="avatar" :src="form.photoUrl" alt />
                </div>
              </div>
            </div> -->
            <!-- <b-field class="field">
              <b-upload v-model="file" @input="upload" accept="image/*">
                <a class="button is-primary">
                  <b-icon icon="upload" custom-size="default"></b-icon>
                  <span>{{ buttonLabel }}</span>
                </a>
              </b-upload>
            </b-field>
            <progress
              v-if="uploadPercent > 0"
              class="progress is-primary"
              :value="uploadPercent"
              max="100"
            >{{uploadPercent}}%</progress> -->
          </form>
        </section>
        <footer class="modal-card-foot">
          <button
            @click="updateUserPressed"
            :disabled="isFormInvalid"
            class="button is-success"
          >Save changes</button>
          <button @click="cancel" class="button">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>



<script>
import axiosInstance from '../../services/axios';
import {
  required,
  email,
  minLength,
  url,
  sameAs
} from 'vuelidate/lib/validators';
import { getAPIEndpoint } from '../../helpers';
export default {
  data() {
    return {
      form: {
        name: this.authUser.name,
        email: this.authUser.email,
        _id: this.authUser._id,
        // isUserVerified: this.authUser.isUserVerified
      },
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      email: {
        required,
        email
      }
      //   password: {
      //     required,
      //     minLength: minLength(6)
      //   },
      //   passwordConfirm: {
      //     required,
      //     sameAsPassword: sameAs('password')
      //   }
    }
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    authUser: {
      type: Object,
      required: true
    }
  },
  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
    // buttonLabel() {
    //   return !this.file ? 'Pick a file' : 'Pick another file';
    // }
  },
  // props: {
  //     authUser: {
  //         type: Object,
  //         required: true
  //     }
  // },
  // methods: {
  //     emitUser () {
  //         this.$emit('userSubmitted', {user: this.user, done: () => this.isOpen = false})
  //     }
  // }
  methods: {
    updateUserPressed() {
      // console.log(this.form);
      this.$v.form.$touch();

      this.$store
        .dispatch('users/updateUser', this.form)
        .then(() => {
          this.isOpen = false;
          this.$emit('cancel');

          this.$buefy.snackbar.open({
            message: 'User Updated Successfully',
            queue: false
          });
        })
        .catch(err => {
          // console.log(err);
          this.$buefy.snackbar.open({
            message: `${err.response.data.message}`,
            queue: false,
          });
        });
    },
    upload(file) {
      this.$emit('input', file);

      this.uploadPercent = 0;

      let formData = new FormData();

      formData.append('image', file);

      axiosInstance
        .post(`${getAPIEndpoint()}/auth/image-upload`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: this.progressEvent
        })
        .then(res => {
          this.form.photoUrl = res.data.imageUrl;
        })
        .catch(err => {
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger'
          });
        });
    },
    progressEvent(progressEvent) {
      this.uploadPercent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>


<style scoped>
.modal-card {
  width: auto;
}

.container {
  width: 50px;
  margin: 0 80%;
}

.level .img {
  right: -112px;
  position: absolute;
  border-radius: 30px;
}
</style>



